import React, { useState } from "react";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";

type Option = {
  id: number;
  text: string;
};

type MultipleChoiceProps = {
  question: string;
  options: Option[];
  onSubmit: (selectedOptions: number[]) => void;
};

export const MultipleChoice: React.FC<MultipleChoiceProps> = ({
  question,
  options,
  onSubmit,
}) => {
  const [selectedOptions, setSelectedOptions] = useState<number[]>([]);

  const handleChange = (id: number) => {
    const updatedOptions = selectedOptions.includes(id)
      ? selectedOptions.filter((optionId) => optionId !== id)
      : [...selectedOptions, id];

    setSelectedOptions(updatedOptions);
    onSubmit(updatedOptions);
  };

  return (
    <div>
      <Typography
        variant="body1"
        fontWeight={500}
        gutterBottom
        textAlign={"left"}
      >
        {question}
      </Typography>
      <FormGroup>
        {options.map((option) => (
          <FormControlLabel
            key={option.id}
            control={
              <Checkbox
                checked={selectedOptions.includes(option.id)}
                onChange={() => handleChange(option.id)}
              />
            }
            label={option.text}
            sx={{
              ".MuiFormControlLabel-label": {
                fontSize: "14px",
                textAlign: "left",
                color: "grey.600",
              },
            }}
          />
        ))}
      </FormGroup>
    </div>
  );
};
